class PremiumFooter extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.mobileQuery = window.matchMedia('(max-width: 989px)');
    this.menus = Array.from(this.querySelectorAll('[data-pf-menu]'));
    this.onBreakpointChange = () => this.syncMenus();
    this.mobileQuery.addEventListener?.('change', this.onBreakpointChange);
    this.syncMenus();
    requestAnimationFrame(() => this.classList.add('is-ready'));

    if (this.dataset.reveal !== 'true' || reduceMotion || !('IntersectionObserver' in window)) {
      this.dataset.visible = 'true';
      return;
    }

    this.observer = new IntersectionObserver(this.onIntersect, {
      rootMargin: '100px 0px',
      threshold: 0.08,
    });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.mobileQuery?.removeEventListener?.('change', this.onBreakpointChange);
  }

  syncMenus() {
    this.menus?.forEach((menu) => {
      if (this.mobileQuery.matches) {
        if (menu.dataset.mobileInitialized !== 'true') {
          menu.open = menu.dataset.mobileOpen === 'true';
          menu.dataset.mobileInitialized = 'true';
        }
      } else {
        menu.open = true;
        delete menu.dataset.mobileInitialized;
      }
    });
  }

  onIntersect = (entries) => {
    if (!entries[0]?.isIntersecting) return;
    this.dataset.visible = 'true';
    this.observer?.disconnect();
  };
}

if (!customElements.get('premium-footer')) {
  customElements.define('premium-footer', PremiumFooter);
}
